import { createContext, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useClientPortalPaths } from "./useClientPortalBase";
import { casamapaPartnerVendorHubPath } from "../constants/casamapaPartnerVendorPaths";

const VendorDirectoryPartnerScopeContext = createContext(null);

export function VendorDirectoryPartnerScopeProvider({
  clientViewId,
  serviciosBase,
  isPartnerPortal = true,
  children,
}) {
  const value = useMemo(
    () => ({
      clientViewId,
      serviciosBase: serviciosBase || casamapaPartnerVendorHubPath(clientViewId, ""),
      isPartnerPortal,
    }),
    [clientViewId, serviciosBase, isPartnerPortal]
  );

  return (
    <VendorDirectoryPartnerScopeContext.Provider value={value}>
      {children}
    </VendorDirectoryPartnerScopeContext.Provider>
  );
}

export function useVendorDirectoryPartnerScope() {
  return useContext(VendorDirectoryPartnerScopeContext);
}

export function useVendorDirectoryPaths() {
  const partnerScope = useVendorDirectoryPartnerScope();
  const paths = useClientPortalPaths();
  const { clientViewId: paramViewId } = useParams();
  const clientViewId = partnerScope?.clientViewId || paramViewId;

  return useMemo(() => {
    const serviciosBase =
      partnerScope?.serviciosBase ||
      (clientViewId ? `${paths.view(clientViewId)}/servicios` : "");

    return {
      clientViewId,
      serviciosBase,
      segment: (...parts) =>
        [serviciosBase, ...parts.filter(Boolean).map((part) => String(part).replace(/^\/+/, ""))]
          .filter(Boolean)
          .join("/"),
      isPartnerPortal: Boolean(partnerScope?.isPartnerPortal),
      isScopedWorkspace: Boolean(partnerScope),
    };
  }, [clientViewId, partnerScope, paths]);
}
